import { type Vector } from "@common/utils/vector";

/*
    On phones, loot at the player's feet is picked up by itself (`cv_autopickup`), so what they had just dropped (from
    the inventory screen or a HUD slot) came straight back. Each item dropped is now left alone until the player has
    walked away from where they dropped it (or a minute has gone by); tapping it still picks it up.
*/

/** how far (in metres) the player walks away from what they dropped before it can be picked up by itself again */
const WALK_AWAY = 6;
const LONGEST = 60_000;

const holds = new Map<string, { readonly at: Vector, readonly until: number }>();

/** what the player just dropped, where they stood: not picked up by itself while they stay there */
export function holdAutoPickup(idString: string, at: Vector | undefined): void {
    if (at === undefined) return;
    holds.set(idString, { at: { x: at.x, y: at.y }, until: Date.now() + LONGEST });
}

/** whether this item was just dropped here, and so isn't to be picked up by itself */
export function autoPickupHeld(idString: string, position: Vector): boolean {
    const hold = holds.get(idString);
    if (hold === undefined) return false;
    if (Date.now() > hold.until || Math.hypot(position.x - hold.at.x, position.y - hold.at.y) > WALK_AWAY) {
        holds.delete(idString);
        return false;
    }
    return true;
}

/** a new match: nothing held */
export function clearAutoPickupHolds(): void {
    holds.clear();
}
